import React, { FC, memo, useCallback } from 'react';

import WalletIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

import { modalActions } from '@contexts/common/ModalContext';

import Button, { ButtonProps } from '@components/common/Button';

import { MODAL_TYPES } from '@constants/common/modals.constants';

interface Props extends ButtonProps {
  onClose?: () => void;
  withIcon?: boolean;
}

const ConnectWalletButton: FC<Props> = ({
  onClose = undefined,
  withIcon = false,
  ...props
}) => {
  const handleOpenWalletModal = useCallback(() => {
    modalActions.show(MODAL_TYPES.CONNECT_WALLET_MODAL);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <Button {...props} onClick={handleOpenWalletModal}>
      {withIcon ? <WalletIcon /> : 'Connect Wallet'}
    </Button>
  );
};

export default memo(ConnectWalletButton);
